

import ImageSlider from './ImageSlider'; 


import PlaygroundImage from '../assets/images/facilities/PLAYGROUND.png';
import PlaygroundImage1 from '../assets/images/facilities/PLAYGROUND1.png';

const images = [
    { src: PlaygroundImage, altText: 'Playground' },
    { src: PlaygroundImage1, altText: 'Playground 1' },
   
];

const Playground = () => {
    return (
        <section className="ftco-section ftco-no-pt ftco-no-pb"> 
            <div className="container">
                <div className="row justify-content-center mt-3 pb-4">
                    <div className="col-md-12 heading-section ftco-animate text px-4">
                        <h2 className="mb-4 text-success text-center">
                            <span className="text-warning">Playground</span> 
                        </h2>   
                    </div>
                </div>
                
                <div className="row mt-3">
                    <div className="col-md-8 order-md-first wrap-about">
                        <div className="text px-4">
                            <p>
                            The playground at Kaamadhenu College of Education provides a spacious and well-maintained area for students to engage in physical activities, sports, and recreational pursuits. It serves as a vital space for promoting physical fitness, teamwork, and overall well-being among student teachers. The playground is equipped with facilities for various sports and activities, encouraging students to maintain an active lifestyle and develop essential life skills through sports and games.
                            </p>
                        </div>
                    </div>
                    <div className=" col-md-4 order-md-first wrap-about">
                    <ImageSlider images={images} />              
                    </div>
                </div>  
            </div>
            <hr className="custom-hr"/>
        </section>
    );
};

export default Playground;
